import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Page } from '@/components/Page/Page';

import styles from './StoreOnboarding.module.css';
import Button from '@/components/Button/Button';
import Input from '@/components/Input/Input';
import { useStoreOnboarding } from '@/services/stores/stores.service';
import { showToast } from '@/components/Toast/Toast';
import { ToastTypes } from '@/components/Toast/Toast.types';

export const StoreOnboarding = () => {
  const { t } = useTranslation();

  const [newStore, setNewStore] = useState<string>('');
  const [copyStore, setCopyStore] = useState<string>('');
  const [error, setError] = useState<string>('');
  const useStoreOnboardingMutation = useStoreOnboarding();

  const handleChange = (setter: React.Dispatch<React.SetStateAction<string>>, value: string) => {
    if (/^\d{0,6}$/.test(value)) {
      setter(value);
    }
  };
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError('');

    if (!newStore.trim() || !copyStore.trim()) {
      setError(t('storeOnboarding.formValidation1'));
      return;
    }
    if (newStore.trim().length !== 6 || copyStore.trim().length !== 6) {
      setError(t('storeOnboarding.formValidation2'));
      return;
    }
    useStoreOnboardingMutation.mutateAsync(
      { newStore, copyStore },
      {
        onSuccess: (data: any) => {
          showToast({
            label: t('storeOnboarding.updated'),
            toastType: ToastTypes.Success,
            id: 'storeOnboarding',
          });
        },
        onError: (data: any) => {
          showToast({
            label: t('error.updatingStoreOnboarding'),
            toastType: ToastTypes.Error,
            id: 'storeOnboarding',
          });
        },
      },
    );
    setNewStore('');
    setCopyStore('');
  };

  return (
    <form onSubmit={handleSubmit}>
      <Page
        title={t('storeOnboarding.title')}
        header={t('storeOnboarding.heading')}
        breadcrumb={{ label: t('breadcrumb.backToHome'), to: '/' }}
      >
        <div>
          <div className={styles.page}>
            <Box>
              <Input
                id="newStore"
                type="text"
                label={t('storeOnboarding.newStore')}
                placeholder={t('storeOnboarding.newStorePlaceHolder')}
                pattern="[0-9]*"
                onChange={(e) => handleChange(setNewStore, e.target.value)}
                maxLength={6}
                value={newStore}
              />
            </Box>
            <Box>
              <Input
                id="copyStore"
                type="text"
                label={t('storeOnboarding.copyStore')}
                placeholder={t('storeOnboarding.copyStorePlaceHolder')}
                pattern="[0-9]*"
                onChange={(e) => handleChange(setCopyStore, e.target.value)}
                maxLength={6}
                value={copyStore}
              />
            </Box>
            <div className={styles.buttonContainer}>
              <Button type="submit">{t('storeOnboarding.buttonTitle')}</Button>
            </div>
          </div>
          {error && <p className={styles.addStoreError}>{error}</p>}
        </div>
      </Page>
    </form>
  );
};
